/** Numeric report values must always be finite, including missing data and ratios. */
export function reportNumber(value) {
  const normalized =
    typeof value === "string" ? value.replace(/,/g, "").trim() : value;
  const number = Number(normalized);
  return Number.isFinite(number) ? number : 0;
}

export function reportDecimal(value, decimals = 2) {
  return reportNumber(value).toFixed(decimals);
}

export function reportRatio(numerator, denominator) {
  const divisor = reportNumber(denominator);
  return divisor === 0 ? 0 : reportNumber(reportNumber(numerator) / divisor);
}
